// MaintenanceDashboard.jsx
import React from "react";
import "../../src/styles/main.css";
import "../../src/styles/filters.css";
import "../../src/styles/cards.css";
import "../../src/styles/charts.css";
import "../../src/styles/tabs.css";

const MaintenanceDashboard = () => {
  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <h1 className="dashboard-title">Dashboard</h1>
        <p className="dashboard-subtitle">
          Comprehensive overview of all maintenance operations
        </p>
      </header>

      <div className="tabs-container">
        <button className="tab-button active" data-tab="pm">
          Preventive Maintenance
        </button>
        <button className="tab-button" data-tab="breakdown">
          Breakdown Maintenance
        </button>
        <button className="tab-button" data-tab="amc">
          AMC
        </button>
        <button className="tab-button" data-tab="hr">
          Human Resources
        </button>
        <button className="tab-button" data-tab="statutory">
          Statutory Approvals
        </button>
        <button className="tab-button" data-tab="stock">
          Stock & PR
        </button>
        <button className="tab-button" data-tab="permit">
          Work Permit
        </button>
        <button className="tab-button" data-tab="audits">
          Audits
        </button>
      </div>

      {/* Preventive Maintenance Section */}
      <div id="pm-section" className="tab-content active">
        <div className="section-header">
          <div className="section-title-wrapper">
            <h2 className="section-title">Preventive Maintenance (PM)</h2>
            <p className="section-description">
              Track scheduled maintenance tasks and completion rates
            </p>
          </div>
          <div className="filters-wrapper">
            <div className="filter-group">
              <label htmlFor="pm-department">Department</label>
              <select id="pm-department" className="filter-select">
                <option value="all">All Departments</option>
                <option value="mechanical">Mechanical</option>
                <option value="electrical">Electrical</option>
                <option value="civil">Civil</option>
                <option value="hvac">HVAC</option>
                <option value="plumbing">Plumbing</option>
              </select>
            </div>
            <div className="filter-group">
              <label htmlFor="pm-date">Date Range</label>
              <select id="pm-date" className="filter-select">
                <option value="today">Today</option>
                <option value="7days">Last 7 Days</option>
                <option value="30days">Last 30 Days</option>
                <option value="month">This Month</option>
                <option value="quarter">This Quarter</option>
                <option value="year">This Year</option>
                <option value="custom">Custom Range</option>
              </select>
            </div>
            <div className="filter-actions">
              <button className="btn-apply" 
            //   onClick={() => applyFilters("pm")}
              >
                Apply
              </button>
              <button className="btn-reset" 
            //   onClick={() => resetFilters("pm")}
              >
                Reset
              </button>
            </div>
          </div>
        </div>

        <div className="kpi-grid">
          <div className="kpi-card">
            <div className="kpi-header">
              <span className="kpi-label">Total Scheduled</span>
              <span className="kpi-icon">📋</span>
            </div>
            <div className="kpi-value">245</div>
            <div className="kpi-footer">
              <span className="kpi-change positive">+12% from last month</span>
            </div>
          </div>
          <div className="kpi-card">
            <div className="kpi-header">
              <span className="kpi-label">Completed</span>
              <span className="kpi-icon">✅</span>
            </div>
            <div className="kpi-value">198</div>
            <div className="kpi-footer">
              <span className="kpi-change positive">+8% from last month</span>
            </div>
          </div>
          <div className="kpi-card">
            <div className="kpi-header">
              <span className="kpi-label">Overdue</span>
              <span className="kpi-icon">⚠️</span>
            </div>
            <div className="kpi-value">23</div>
            <div className="kpi-footer">
              <span className="kpi-change negative">-5% from last month</span>
            </div>
          </div>
          <div className="kpi-card">
            <div className="kpi-header">
              <span className="kpi-label">Completion Rate</span>
              <span className="kpi-icon">📊</span>
            </div>
            <div className="kpi-value">80.8%</div>
            <div className="kpi-footer">
              <span className="kpi-change positive">+3% from last month</span>
            </div>
          </div>
        </div>

        <div className="charts-grid">
          <div className="chart-card">
            <h3 className="chart-title">Monthly Completion Trend</h3>
            <canvas id="pm-trend-chart"></canvas>
          </div>
          <div className="chart-card">
            <h3 className="chart-title">Department-wise Breakdown</h3>
            <canvas id="pm-department-chart"></canvas>
          </div>
        </div>
      </div>

      {/* Breakdown Maintenance Section */}
      <div id="breakdown-section" className="tab-content">
        {/* Repeat the same structure for all other sections */}
        {/* ... */}
      </div>
    </div>
  );
};

export default MaintenanceDashboard;